import * as React from "react";

const Pencil = ({ size = 24, color = "currentColor", ...props }) => {
    const defaultWidth = 13;
    const defaultHeight = 13;
    const viewBox = `0 0 ${defaultWidth} ${defaultHeight}`;

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox={viewBox}
            fill="none"
            stroke={color}
            strokeWidth={1.2}
            strokeLinecap="round"
            strokeLinejoin="round"
            {...props}
        >
            <path d="M4.293 12.293H1.5a.5.5 0 0 1-.5-.5V9a.5.5 0 0 1 .146-.354l7.5-7.5a.5.5 0 0 1 .708 0l2.792 2.793a.5.5 0 0 1 0 .707l-7.5 7.5a.499.499 0 0 1-.353.147ZM7 2.793l3.5 3.5M4.468 12.261 1.032 8.825" />
        </svg>
    );
};

export default Pencil;
